// ============================================================================
// Plan Definitions
// ============================================================================

export type PlanId = 'free' | 'pro'

export interface PlanDefinition {
  id: PlanId
  name: string
  price: number // monthly in USD, 0 for free
  fillsPerMonth: number | null // null = unlimited
  features: string[]
}

export const PLANS: Record<PlanId, PlanDefinition> = {
  free: {
    id: 'free',
    name: 'Free',
    price: 0,
    fillsPerMonth: 10,
    features: [
      '10 autofills per month',
      'Full dashboard, tracker, and analytics',
      'Browser extension with field detection',
      'Cloud sync and account access',
    ],
  },
  pro: {
    id: 'pro',
    name: 'Pro',
    price: 4.99,
    fillsPerMonth: null,
    features: [
      'Unlimited autofill',
      'Everything in Free',
      'Best for heavy application volume',
    ],
  },
}

export const FREE_FILL_LIMIT = 10
